import { render } from "./RewardBlastRule.vue?vue&type=template&id=567a1038"
import script from "./RewardBlastRule.vue?vue&type=script&lang=js"
export * from "./RewardBlastRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__